/* eslint-disable @babel/no-invalid-this */
document.body.addEventListener(
  'click',
  (event) => {
    if (!event.target.matches('.quantity_parent_child .catalog--qty-adjuster')) return;

    const targetElement = event.target;
    
    

    if (targetElement.classList.contains('catalog--js--add')) {
      let addNext = parseInt(targetElement.getAttribute('data-qty'));
      targetElement.setAttribute('data-qty', addNext + 1);
      targetElement.parentNode.querySelector('.catalog--js--minus').setAttribute('data-qty', addNext - 1);
      targetElement.parentNode.querySelector('input').value = addNext;

      // document.querySelector('.btn--add-to-cart').removeAttribute('disabled');
      // targetElement.parentNode.parentNode.nextSibling.removeAttribute('disabled');
    } else if (targetElement.classList.contains('catalog--js--minus')) {
      var addPrev = parseInt(targetElement.getAttribute('data-qty'));

      if (addPrev > 1) {
        targetElement.parentNode.querySelector('input').value = addPrev;
        targetElement.parentNode.querySelector('.catalog--js--add').setAttribute('data-qty', addPrev + 1);
        targetElement.setAttribute('data-qty', addPrev - 1);

        // document.querySelector('.btn--add-to-cart').removeAttribute('disabled');
        // targetElement.parentNode.parentNode.nextSibling.removeAttribute('disabled');
      } else if (addPrev == 1) {
        targetElement.parentNode.querySelector('input').value = addPrev;
        targetElement.parentNode.querySelector('.catalog--js--add').setAttribute('data-qty', 2);
        targetElement.setAttribute('data-qty', addPrev - 1);

        // document.querySelector('.btn--add-to-cart').removeAttribute('disabled');
        // targetElement.parentNode.parentNode.nextSibling.removeAttribute('disabled');
      }
    }
  },
  false,
);

// Guide popup display

// const guideBtn = document.querySelectorAll('.buyers-guide a.buyers-guide-link');
// for (let i = 0; i < guideBtn.length; i++) {
//   // eslint-disable-next-line no-empty-function, id-length
//   guideBtn[i].addEventListener('click', (e) => {
//     e.preventDefault();
//     e.target.closest('.buyers-guide').querySelector('.buyers-guide-content').classList.add('active');
//   });
// }

// const guideCls = document.querySelectorAll('.buyers-guide-content .close');
// for (let i = 0; i < guideCls.length; i++) {
//   // eslint-disable-next-line no-empty-function, id-length
//   guideCls[i].addEventListener('click', (e) => {
//     e.preventDefault();
//     e.target.closest('.buyers-guide').querySelector('.buyers-guide-content').classList.remove('active');
//   });
// }

// let ymmproduct = '{{ settings.ymm_api_base_url }}';

// document.body.addEventListener('click', function (event) {
//   if (event.target.classList.contains('buyers-guide-link')) {
//     var buyersGuideContent = document.querySelector('.buyers-guide-content');
//     buyersGuideContent.classList.remove('active');

//     var limit = 10;
//     var page = 1;

//     var product_id = event.target.getAttribute('data-prod-id');
//     var targetElement = document.querySelector('#buyers_' + product_id);
//     targetElement.classList.add('active');

//     var requestUrl = new URL(ymmproduct);
//     requestUrl.searchParams.append('type', 'ajax');
//     requestUrl.searchParams.append('request', 'compatibility');
//     requestUrl.searchParams.append('product', product_id);
//     requestUrl.searchParams.append('page', page);
//     requestUrl.searchParams.append('limit', limit);

//     fetch(requestUrl)
//       .then((response) => response.json())
//       .then(function (data) {
//         var list_html = '';
//         if (data.length > 0) {
//           for (var i = 0; i < data.length; i++) {
//             list_html +=
//               '<tr><td>' +
//               data[i]['value_name4'] +
//               '</td><td>' +
//               data[i]['value_name3'] +
//               '</td><td>' +
//               data[i]['value_name2'] +
//               '</td><td>' +
//               data[i]['value_name1'] +
//               '</td></tr>';
//           }

//           document.querySelector('#buyers_' + product_id + ' tbody').innerHTML = list_html;
//         } else {
//           list_html += '<tr><td colspan="5" style="text-align:center">No results found!</td></tr>';
//           document.querySelector('#buyers_' + product_id + ' tbody').innerHTML = list_html;
//         }
//       });
//   }
// });
